import React, {createRef, useState, useContext} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../../controls/Material-Table-Components';

import SystemContext from "../../../../SystemContext";
import {Selector} from "../../../../controls";
import PersonLookup from "../../../Persons/components/PersonLookup";
import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import PaxEditorValidator from "../../validators/PaxEditorValidator";
import { useTheme } from '@material-ui/core';


const PaxEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('Pax.AddPassenger', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const props = {
    ..._props
  }
  const {classes, flightRecord} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const getPassports = (passports) => {
    const passportsData = {passport: null, passportLookupValues: null};
    if (passports && Array.isArray(passports)) {
      const passportLookupValues = {};
      for (let i = 0; i < passports.length; i++) {
        const passport = passports[i];
        if (__.has(passport, "default") && passport.default)
          passportsData["passport"] = passport;
        passportLookupValues[`${passport.passportNumber}`] = `${passport.countryCode} - ${passport.passportNumber} (expires: ${passport.expiryDate})`;
      }
      passportsData["passportLookupValues"] = passportLookupValues;
    }
    return passportsData;
  }

  const flightPax = flightRecord.passengers || [];
  flightPax.forEach(passenger => {
    const {passportLookupValues} = getPassports(passenger?.passports);
    passenger["passportLookupValues"] = passportLookupValues;
  });

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(PaxEditorValidator, false);

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(400,6,undefined,undefined,undefined,undefined,false),
        title: "Passenger",
        field: "passengerUuid",
        editComponent: (props) => (
          <PersonLookup
            value={props.rowData.passengerUuid}
            readOnly={!state.canEdit}
            returnType={"object"}
            includeNew={true}
            onChange={(returnObject) => {
              if (returnObject.found) {
                const person = returnObject.data;
                const {passport, passportLookupValues} = getPassports(person?.passports);
                const data = {
                  ...props.rowData,
                  passengerUuid: person.personUuid,
                  ...__.omit(person, ["personUuid"]),
                  passport: passport,
                  passportNumber: passport ? passport.passportNumber : null,
                  passportLookupValues
                }
                props.onRowDataChange(data);
              } else {
                props.onChange(returnObject.value);
              }
            }}
          />
        ),
        render: (rowData) => (
          <span>{`${rowData.title} ${rowData.knownAs}`}</span>
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(400,2,undefined,undefined,undefined,undefined,false),
        title: "Passport",
        field: "passportNumber",
        editComponent: (props) => (
          <Selector
            value={props.value}
            lookupValues={props?.rowData?.passportLookupValues}
            onChange={(value) => {
              const passports = props.rowData.passports;
              const data = {
                ...props.rowData,
                passport: passports[value],
                passportNumber: passports[value].passportNumber,
              }
              props.onRowDataChange(data);
            }}
          />
        ),
        render: (rowData) => {
          return (<span>{rowData.passport ? `${rowData.passport.countryCode} - ${rowData.passport.passportNumber} (expires: ${rowData.passport.expiryDate})`: ""}</span>)
        }
      },
    ];
  };

  const bodyRef = createRef();

  return (isAuthenticated &&
    <div className={classes.TripLegEditor}>
      <MaterialTable
        tableRef={tableRef}
        data={flightPax}
        style={{
          backgroundColor: "#fdfdfd",
          boxShadow: "none",
          border: "2px solid #aaaaaa",
          borderRadius: 0,
        }}
        options={{
          actionsColumnIndex: -1,
          search: false,
          cellStyle: {
            padding: "8px 2px",
          },
          headerStyle: {
            backgroundColor: theme.palette.childTableHeader.backgroundColor,
            color: theme.palette.childTableHeader.textColor,
            padding: "2px",
          },
          toolbarButtonAlignment: "right",
          detailPanelType: "single",
          showTitle: false,
          toolbar: false,
          padding: 'dense',
          paging: false,
          filtering: false,
          draggable: false,
        }}
        components={{
          ...defaultComponents,
          Body: (props) => (
            <MaterialTableBody
              {...props}
              ref={bodyRef}
              rowHeight={46}
              overscanRowCount={10}
              addVirtualScrolling={true}
              bodyHeight={250}
              headerHeight={46}
            />
          ),
          Row: (props) => (
            <MaterialTableBodyRow {...props} />
          ),
        }}
        title="Flight Passengers"
        columns={getColumns({...props, canEdit: state.canEdit})}
        actions={[
        ]}
        editable={{
          isEditable: () => {
            return state.canEdit;
          },
          isDeletable: () => {
            return state.canEdit;
          },
          onRowAdd: state.canEdit
              ? (newData) => new Promise((resolve, reject) => {
                if (Array.isArray(flightPax)) {
                  flightPax.push({...newData});
                  props.onChange({record: {...props.flightRecord, passengers: flightPax}, oldRecord: props.flightRecord, resolve, reject});
                } else {
                  reject();
                }
              })
              : undefined,
          onRowUpdate: state.canEdit
              ? (newData, oldData) => new Promise((resolve, reject) => {
                  const paxIdx = __.findIndex(flightPax, {passengerUuid: oldData.passengerUuid});
                  if (paxIdx >= 0) {
                    flightPax[paxIdx] = newData;
                    props.onChange({record: {...props.flightRecord, passengers: flightPax}, oldRecord: props.flightRecord, resolve, reject});
                  } else {
                    reject();
                  }
                })
              : undefined,
          onRowDelete: state.canEdit
            ? (oldData) => new Promise((resolve, reject) => {
                const paxIdx = __.findIndex(flightPax, {passengerUuid: oldData.passengerUuid});
                if (paxIdx >= 0) {
                  flightPax.splice(paxIdx, 1);
                  props.onChange({record: {...props.flightRecord, passengers: flightPax}, oldRecord: props.flightRecord, resolve, reject});
                } else {
                  reject();
                }
              })
            : undefined,
        }}
      />
    </div>
  );
}

export default PaxEditor;
